import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";

export const SITE = {
  phone: "(775) 577-7577",
  phoneHref: "tel:+17755777577",
  email: "info@sterlingwestinsurance.com",
  address: "1720 E Washington Blvd, Pasadena, CA",
  city: "Pasadena, California",
};

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-white border-t border-neutral-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size="md" />
            <p className="mt-6 max-w-sm text-neutral-600 leading-relaxed">
              Insurance done with clarity, speed, and taste. An independent
              brokerage built for people who expect more from their coverage.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-5">
              Contact
            </div>
            <ul className="space-y-4 text-[15px]">
              <li>
                <a
                  href={SITE.phoneHref}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-2 text-neutral-800 hover:text-black"
                >
                  <Phone size={15} /> {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 text-neutral-800 hover:text-black"
                >
                  <Mail size={15} /> {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-neutral-800">
                <MapPin size={15} className="mt-[3px] shrink-0" />
                <span data-testid="footer-address">{SITE.address}</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-5">
              Coverage
            </div>
            <ul className="space-y-3 text-[15px] text-neutral-800">
              <li>Auto</li>
              <li>Home</li>
              <li>Commercial</li>
              <li>Life</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.18em] text-neutral-500 mb-5">
              Company
            </div>
            <ul className="space-y-3 text-[15px] text-neutral-800">
              <li>
                <a href="/#why" className="hover:text-black">Why SWIA</a>
              </li>
              <li>
                <a href="/#process" className="hover:text-black">Process</a>
              </li>
              <li>
                <Link to="/quote" data-testid="footer-quote-link" className="hover:text-black">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Big wordmark — SVG so it always spans the full container width */}
        <div className="mt-20 border-t border-neutral-200 pt-12">
          <svg
            viewBox="0 0 100 18"
            preserveAspectRatio="xMidYMid meet"
            className="block w-full select-none"
            aria-hidden="true"
          >
            <text
              x="50"
              y="16"
              textAnchor="middle"
              fontFamily="Cabinet Grotesk, Satoshi, sans-serif"
              fontWeight="900"
              fontSize="18"
              letterSpacing="0.4"
              fill="#0a0a0a"
            >
              SWIA
            </text>
          </svg>
        </div>

        <div className="mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Sterling West Insurance Agency. All rights reserved.</div>
          <div>CA License #4460364 · Independent Brokerage</div>
        </div>
      </div>
    </footer>
  );
}
